import compose from 'ramda/src/compose'
import { updateImage } from '../../../../store/modules/profile'
import ProfileImageForm from './ProfileImageForm'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  locale: state.router.locale,
  uploaded: state.profile.imageUpdateSuccess,
  uploading: state.profile.isUpdatingImage,
  user: state.profile.user,
  error: state.profile.imageUpdateError,
})

const mapDispatchToProps = dispatch => ({
  updateImage: compose(dispatch, updateImage),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProfileImageForm)
